import OrderPaymentAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity';
import { DecimalPipe } from '@angular/common';
import omit from 'lodash-es/omit';
import { OrdersPaymentCListCommonExportProcessor } from './order-payment-c-list-common';

export class OrdersPaymentCListJsonExportProcessor extends OrdersPaymentCListCommonExportProcessor {
  constructor(decimalPipe: DecimalPipe) {
    super(decimalPipe);
  }

  protected override transformForMainSection(item: OrderPaymentAttributes) {
    return {
      ...super.transformForMainSection(item),
      details: super.transformForDetailsSection(item).map((data) => omit(data, 'serial', 'trip')),
    }
  }

  override onAddData(item: OrderPaymentAttributes) {
    this.addToSection('orders', this.transformForMainSection(item));
  }
}
